import styled from "styled-components"

export default styled.img`
  padding-top: 5px;
`
